import LayoutBasic from '../layouts/layoutBasic'
import { withRouter } from 'next/router'
import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart, faMapMarkerAlt, faCopy, faCheck, faEye } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin, faFacebookF, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'
import Link from 'next/link'
import {
  TOKEN, GET_PHOTO_DETAIL_URL, RELATED_PHOTOS,
  DOWNLOAD_PHOTO_FROM_SUBSCRIPTION, GET_USER_URL, SITE_URL,
  GET_CUSTOMER_SUBSCRIPTION, CURRENT_SEARCH_TERM, ADD_PHOTO_TO_CART_URL, CART, ASSET_PROFILE_URL, DOWNLOAD_SAMPLE
} from '../vars'
import { setLocalKeyValue, getLocalKeyValue, setSessionKeyValue, getJsonData, setJsonData } from '../storage'
import Error from 'next/error'
import CartContext from '../ctx/cartContext'
import axios from 'axios'
import FileDownload from '../components/filedownload'
import ListPhoto from '../components/listPhoto'
import { GET, POST } from '../helpers'
import ShowMoreText from 'react-show-more-text'
import Favorite from '../components/favorite'
import VisibilitySensor from 'react-visibility-sensor'
import { SeoMetaPhoto } from '../components/seoMeta'
import Clipboard from 'clipboard'
import Img from 'react-image'
import { logEvent } from '../components/analytics'
import { Modal } from 'react-bootstrap'
import slugify from 'slugify'
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap'
import getPriceList from '../components/priceList';
import checkIsOutsideIndia from '../components/checkIsOutsideIndia'

function SeeMoreList(props) {
  const [seeMore, setSeeMore] = useState(false)
  let list = props.data
  let title = props.title
  let list_render = null
  let show_items = props.show_items ? props.show_items : 8


  if (list.length > show_items) {
    let list_slice = seeMore ? list : list.slice(0, show_items)
    let text = seeMore ? "See less" : "See more"

    list_render = list_slice.map((tag, id) => {
      return <li className=" list-inline-item " key={id}>
        <Link as={`/search/${tag.search_slug}`} href={"/search?q=" + tag.search_slug}><a className="btn btn-outline-secondary me-1 mb-2">
          {tag.name}
        </a></Link>
      </li>
    })
    list_render = <>{list_render} <li className="list-inline-item"><a className="btn btn-link me-1 mb-2" onClick={(e) => { setSeeMore(!seeMore) }}>{text}</a></li></>
  }
  else {
    list_render = list.map((tag, id) => {
      return <li className="list-inline-item" key={id}>
        <Link as={`/search/${tag.search_slug}`} href={"/search?q=" + tag.search_slug}><a className="btn btn-outline-secondary me-1 mb-2">
          {tag.name}
        </a></Link>
      </li>
    })
  }
  return <ul className="list-inline">
    {list_render}
  </ul>

}
export function Creator(props) {


  let photographer = props.photographer
  let need_by = props.need_by ? false : true
  let profilePicRender, by_text
  if (photographer.profile_pic.img) {
    profilePicRender = <img key={photographer.username} src={photographer.profile_pic.img}
      className="align-self-center me-3 rounded-circle" alt={photographer.username} width="36" height="36" />
  }
  else {
    profilePicRender = <picture>
      <source srcSet={photographer.profile_pic.webp_65} type="image/webp" />
      <source srcSet={photographer.profile_pic.jpeg_65} type="image/jpeg" />
      <img key={photographer.username} src={photographer.profile_pic.jpeg_65}
        className="align-self-center me-3 rounded-circle" alt={photographer.username} width="36" height="36" />
    </picture>
  }
  if (need_by) {
    by_text = <span>By </span>
  }

  let profileLink
  if (props.videoContext) {
    profileLink = <><span>
      <Link as={`/${photographer.username}/videos`} href={"/?type=videos&username=" + photographer.username}>
        <a href={`/${photographer.username}/videos`} title={"View videos by " + photographer.username}>
          {profilePicRender}
        </a>
      </Link>
    </span>
      <span>
        {by_text} <Link as={`/${photographer.username}/videos`} href={"/?type=videos&username=" + photographer.username}>
          <a href={`/${photographer.username}/videos`} title={"View videos by " + photographer.first_name} className='fw-500'>
            {photographer.first_name + (photographer.last_name ? (' ' + photographer.last_name) : '')}
          </a>
        </Link>
      </span></>
  }
  else {
    profileLink = <><span>
      <Link as={`/${photographer.username}`} href={"/?username=" + photographer.username}>
        <a href={`/${photographer.username}`} title={"View photos by " + photographer.username}>

          {profilePicRender}
        </a>
      </Link>
    </span>
      <span>
        {by_text} <Link as={`/${photographer.username}`} href={"/?username=" + photographer.username}>
          <a href={`/${photographer.username}`} title={"View photos by " + photographer.first_name} className='fw-500'>
            {photographer.first_name + (photographer.last_name ? (' ' + photographer.last_name) : '')}
          </a>
        </Link>
      </span></>
  }



  return <div className="mb-4 mb-sm-0 d-flex align-items-center">
    {profileLink}
  </div>

}

class Photo extends React.Component {

  constructor(props) {
    super(props)
    this.wrapperRef = React.createRef();
    this.addToCart = this.addToCart.bind(this);
    this.updatePriceList = this.updatePriceList.bind(this);
    this.state = {
      selected_option: 'digital',
      download_success: false, download_failed: false, downloading: false, msg: "", userSigndStatus: false,
      added_to_cart: false, showShare: false, download_failed_low: false, show_print_image: true,
      isOutsideIndia: false,
      latitude: null,
      longitude: null,
      priceList: {},
      error: null,
      apiPrices: {},
    }
  }

  componentDidMount() {
    const { latitude, longitude } = this.props;

    // More accurate bounds for India
    const isOutsideIndia = checkIsOutsideIndia(latitude, longitude);
    this.setState({ isOutsideIndia })

    if (this.props && this.props.user) {
      this.setState({ userSigndStatus: true });
    }

    let cb = new Clipboard('.cbtn')
    cb.on('success', (e) => {
      e.trigger.lastChild.innerHTML = "<small class='text-success ms-2'>copied!</small>"
      setTimeout(() => {
        e.trigger.lastChild.innerHTML = ""
      }, 500)
    })
    document.addEventListener('mousedown', this.handleClickOutside);
    let show_print = ((this.props && this.props.attached_options && this.props.attached_options.digital_width && this.props.attached_options.image_width) &&
      ((this.props.attached_options.image_height * this.props.attached_options.image_height) <= (this.props.attached_options.digital_width * this.props.attached_options.digital_height))) ? false : true
    this.setState({ show_print_image: show_print })

    this.setState({
      latitude: latitude,  // Latitude for San Francisco, US
      longitude: longitude, // Longitude for San Francisco, US
      error: null,
      apiPrices: {}

    }, () => { this.updatePriceList() });
  }



  updatePriceList = () => {
    const { latitude, longitude, apiPrices } = this.state;
    const priceList = getPriceList(latitude, longitude, apiPrices);
    this.setState({ priceList });
  }




  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ showShare: false })
    }
  }


  toggleLicense = (e) => {
    //e.preventDefault();
    this.setState({ show_license: !this.state.show_license })

  }

  addToCart(e) {
    let token = getLocalKeyValue(TOKEN)
    if (token) {
      e.preventDefault()
      let chosen_option = this.state.selected_option
      let photo_id = this.props.photo.id
      let currency = this.state.isOutsideIndia ? "USD" : "INR"

      return POST(ADD_PHOTO_TO_CART_URL, token, { chosen_option: chosen_option, photo_id: photo_id, currency: currency })
    }
    else {
      let ref = "/photo/" + this.props.photo.id
      setSessionKeyValue('referer', ref)
      window.location.href = "/login-customer"
    }
  }

  fetchRelatedPhotos = (isVisible) => {
    if (isVisible && !this.state.fetching_related) {
      const currentRelatedPhotosPage = this.state.related_photos_current_page || this.props.related_photos_current_page
      const nextPage = (parseInt(currentRelatedPhotosPage) + 1)
      this.setState({ 'fetching_related': true })
      GET(RELATED_PHOTOS + '?photo_id=' + this.props.photo.id + "&page=" + nextPage).then((res) => {

        let currentRelatedPhotos = this.state.related_photos || this.props.related_photos

        currentRelatedPhotos = currentRelatedPhotos.concat(res.data.photos)
        this.setState({
          related_photos_current_page: res.data.page,
          related_photos: currentRelatedPhotos,
          fetching_related: false
        })
      })
    }

  }

  getRelatedPhotos = () => {

    const currentRelatedPhotosPage = this.state.related_photos_current_page || this.props.related_photos_current_page
    const nextPage = (parseInt(currentRelatedPhotosPage) + 1)
    GET(RELATED_PHOTOS + '?photo_id=' + this.props.photo.id + "&page=" + nextPage).then((res) => {

      let currentRelatedPhotos = this.state.related_photos || this.props.related_photos

      currentRelatedPhotos = currentRelatedPhotos.concat(res.data.photos)
      this.setState({
        related_photos_current_page: res.data.page,
        related_photos: currentRelatedPhotos,
      })
    })
  }

  downloadPhotoFromSubscription(e, type, photo) {
    this.setState({ downloading: true })

    let filename = 'picxy_' + photo.pid
    axios({
      url: DOWNLOAD_PHOTO_FROM_SUBSCRIPTION + '?photo_id=' + photo.id + '&type=' + type,
      method: 'GET',
      headers: {
        'Authorization': 'Token ' + getLocalKeyValue(TOKEN)
      },
      responseType: 'blob',
    }).then((response) => {
      filename = filename + '.jpg'
      FileDownload(response.data, filename)
      this.setState({ downloading: false, download_success: true })
    }).catch((err, res) => {
      if (err.response.status === 400) {
        this.setState({ download_failed_low: true })
      }
      this.setState({ downloading: false, download_failed: true })
    });
  }

  get_url_extension(url) {
    return url.split(/[#?]/)[0].split('.').pop().trim();
  }

  downloadSamplePhoto(e, photo) {
    if (!(this.state.userSigndStatus)) {
      let ref = "/photo/" + this.props.photo.id
      setSessionKeyValue('referer', ref)
      window.location.href = "/login-customer"
      return
    }
    let url = photo.thumbnail_large ? photo.thumbnail_large : ((photo.thumbs && photo.thumbs.webp_1600) ? photo.webp_1600 : photo.webp_700)
    let url_file_xtension = this.get_url_extension(url)
    let filename = slugify(photo.title) + "-picxy-" + photo.pid + '.' + url_file_xtension
    let api_url = DOWNLOAD_SAMPLE + '?imgUrl=' + encodeURIComponent(url) + '&imgFileName=' + filename + '&imgContentType=' + ((url_file_xtension == 'jpeg' || url_file_xtension == 'jpg') ? "image/jpeg" : "image/webp")
    fetch(api_url, {
    })
      .then((response) => {
        return response.blob();
      })
      .then(blob => {
        FileDownload(blob, filename)
        logEvent('Photo', 'Sample Download', photo.id + "")
      });
  }

  handleSelectPriceOption = (e, option) => {

    if (this.state.selected_option !== option) {
      this.setState({ download_failed: false })
    }

    this.setState({
      selected_option: option
    })
  }

  toggleZoom = () => {
    if (!this.state.zoom) {
      logEvent('Photo', 'Zoom', this.props.photo.id + "")
    }
    this.setState({ zoom: !this.state.zoom })
  }
  //
  // componentWillReceiveProps(props) {
  //
  //   const existingPhoto = this.props.photo
  //   const newPhoto = props.photo
  //   if(existingPhoto.id !== newPhoto.id) {
  //     this.setState({
  //       related_photos_current_page: 0,
  //       related_photos: undefined,
  //       selected_option:null,
  //     })
  //   }
  //
  // }

  componentDidUpdate(props) {
    const existingPhoto = this.props.photo
    const newPhoto = props.photo
    if (existingPhoto && existingPhoto.id !== newPhoto.id) {
      this.setState({
        related_photos_current_page: 0,
        related_photos: undefined,
        selected_option: 'digital',
      })
    }
  }

  updateLikeCount = (liked) => {
    let photo = this.props.photo
    photo.likes = photo.likes + (liked ? 1 : -1)
    let likeCountVar = "count_" + photo.id

    this.setState({ [likeCountVar]: photo.likes })
    if (liked) {
      logEvent('Photo', 'Liked', photo.id + '')
    }

  }

  // static async getInitialProps(props) {

  //   let token = process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token
  //   let data, photoRequest

  //   try {
  //     photoRequest = await GET(GET_PHOTO_DETAIL_URL + "?id=" + props.query.id + '&related=yes')
  //     data = await photoRequest?.data
  //     console.log("dataphoto", data.photo)
  //   } catch (e) {
  //     return { error_code: e.message }
  //   }


  //   const current_search_term = props.query.q

  //   let sub_request, sub_response = {}
  //   try {
  //     if (token) {
  //       sub_request = await axios({
  //         url: GET_CUSTOMER_SUBSCRIPTION,
  //         headers: {
  //           'Authorization': 'Token ' + token
  //         }
  //       })

  //       sub_response = sub_request.data
  //     }

  //   } catch (e) {
  //     sub_response = {}
  //   }

  //   let infoRequest, infoResponse = {}
  //   if (token) {
  //     try {
  //       infoRequest = await GET(GET_USER_URL, token)
  //       infoResponse = await infoRequest.data
  //     } catch (e) {

  //     }
  //   }

  //   return {
  //     current_search_term: current_search_term,
  //     token: token,
  //     user: infoResponse.user,
  //     cart: infoResponse.cart,
  //     subscription: sub_response.subscription,
  //     likes: infoResponse.likes,
  //     photo: data?.photo || {},
  //     mentioned_collections: data.collections,
  //     mentioned_tags: data.tags,
  //     related_photos: data.related_photos,
  //     related_photos_pages: data.related_photos_pages,
  //     related_photos_current_page: 1,
  //     attached_options: data.photo_options,
  //     mr: data.mr,
  //   }
  // }

  static async getInitialProps(props) {
    let token = process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token;
    let data = {}, photoRequest;

    try {
      // Fetch photo details
      photoRequest = await GET(GET_PHOTO_DETAIL_URL + "?id=" + props.query.id + '&related=yes');
      data = photoRequest?.data || {};  // Ensure data is an object, even if undefined
    } catch (e) {
      return { error_code: e.message };
    }

    const current_search_term = props.query.q;

    let sub_request, sub_response = {};
    try {
      if (token) {
        sub_request = await axios({
          url: GET_CUSTOMER_SUBSCRIPTION,
          headers: {
            'Authorization': 'Token ' + token
          }
        });

        sub_response = sub_request.data;
      }
    } catch (e) {
      sub_response = {};
    }

    let infoRequest, infoResponse = {};
    if (token) {
      try {
        infoRequest = await GET(GET_USER_URL, token);
        infoResponse = await infoRequest.data;
      } catch (e) {
        infoResponse = {};
      }
    }

    // Return the data ensuring fallback values if anything is undefined
    return {
      current_search_term: current_search_term,
      token: token,
      user: infoResponse?.user || null,
      cart: infoResponse?.cart || null,
      subscription: sub_response?.subscription || null,
      likes: infoResponse?.likes || [],
      photo: data?.photo || {},  // Check data and data.photo
      mentioned_collections: data?.collections || [],
      mentioned_tags: data?.tags || [],
      related_photos: data?.related_photos || [],
      related_photos_pages: data?.related_photos_pages || 1,
      related_photos_current_page: 1,
      attached_options: data?.photo_options || [],
      mr: data?.mr || null,
    };
  }



  showShareBox = (e) => {
    this.setState({ showShare: !this.state.showShare })
  }

  render() {

    const { priceList } = this.state;

    if (this.props.error_code) {
      return <Error statusCode={this.props.error_code} />
    }

    let photo = this.props.photo

    let viewCountVar = photo.views
    let viewCount
    if (viewCountVar) {
      viewCount = <div className="me-3">
        <img src="/static/img/details_photo/eye.svg" className="img-fluid me-1" /> {viewCountVar} {viewCountVar > 1 ? "Views" : "View"}
      </div>
    }

    let browser_title = "Image of " + photo.title + "-" + photo.pid + "-Picxy"
    let aos = this.props.attached_options
    let subscription = this.props.subscription
    let mentioned_collections = this.props.mentioned_collections
    let mentioned_tags = this.props.mentioned_tags

    let photographer = photo.photographer
    let creditsInfo, creditsMsg, cpyBtn, stockIDcpyBtn, stockIDMsg, copytoClipboard, copytoClipboardbtn

    if (photographer) {
      creditsMsg = "Image Credit: Picxy.com/" + photographer.username
      cpyBtn = <button className="btn cbtn  text-muted" title="Copy Credit Text" data-clipboard-text={"Image Credit: Picxy.com/" + photographer.username}>
        <FontAwesomeIcon icon={faCopy} />
        <span></span></button>

    }
    if (photo) {
      stockIDMsg = '#' + photo.pid
      stockIDcpyBtn = <button className="btn cbtn  text-muted" title="Copy stock photo id" data-clipboard-text={stockIDMsg}>
        <FontAwesomeIcon icon={faCopy} />
        <span></span></button>

      copytoClipboard = SITE_URL + this.props.router.asPath
      copytoClipboardbtn = <a href="#" className="cbtn " title="Copy Link" data-clipboard-text={copytoClipboard}>
        <FontAwesomeIcon icon={faCopy} /> Copy link
        <span></span></a>

    }


    let liked = false
    if (this.props.likes) {
      liked = this.props.likes.indexOf(photo.id) > -1
    }


    let like_btn = <Favorite liked={liked} photo={photo} inLine={true} updateLikeCount={this.updateLikeCount} reference={'/photo/' + this.props.photo.id}></Favorite>

    let digital_price_option, print_price_option

    let digital_lable_className = "p-2 pointer border-bottom"
    let print_lable_className = "p-2 pointer"

    let image_digital_price = <>
      {/* <div className="f-20 text-dark text-right">&#8377; 200</div> */}
      <div className="f-20 text-dark text-end fw-bold">{priceList["Digital Image"]?.price}</div>
      <div className="text-secondary">(1 credit)</div>
    </>
    let image_print_price = <>
      {/* <div className="f-20 text-dark text-right">&#8377; 2000</div> */}
      <div className="f-20 text-dark text-end fw-bold">{priceList["Print Image"]?.price}</div>
      <div className="text-secondary">(10 credits)</div>
    </>

    if ((subscription && subscription.credits_remaining && subscription.credits_remaining > 0) || (subscription && subscription.plan_name === "Postpaid")) {
      image_digital_price = <span className="f-20 text-dark">1 Credit</span>
      image_print_price = <span className="f-20 text-dark">10 Credits</span>
    }


    if (this.state.selected_option === "digital") {
      digital_lable_className += " bg-dull-secondary"
    }
    if (this.state.selected_option === "print") {
      print_lable_className += " bg-dull-secondary"
    }

    let add_to_cart_btn
    if (aos.digital_width) {

      digital_price_option = <div className={digital_lable_className}  >
        <div className="form-check" role="button">
          <input type="radio"
            id="printOptionOne"
            name="photoPrice"
            value="digital"
            className="form-check-input"
            defaultChecked
            role="button"
            onClick={(e) => { this.handleSelectPriceOption(e, 'digital') }} checked={this.state.selected_option === "digital" ? true : false} />
          <label className="form-check-label pointer d-block" htmlFor="printOptionOne">
            <div className="d-flex">
              <div>
                <div className="text-dark" style={{ fontWeight: '500' }}>Digital Usage</div>
                <div className="mt-1">{aos.digital_width}<b> x </b>{aos.digital_height} px</div>
              </div>
              <div className="ms-auto me-2 text-end g">
                {image_digital_price}
              </div>
            </div>
          </label>
        </div>

      </div>
    }
    if (aos.image_width && this.state.show_print_image) {

      print_price_option = <div className={print_lable_className}>
        <div className="form-check">
          <input type="radio"
            id="printOptionTwo"
            value="print"
            name="photoPrice" className="form-check-input"

            onClick={(e) => { this.handleSelectPriceOption(e, 'print') }} checked={this.state.selected_option === "print" ? true : false} />

          <label className="form-check-label pointer d-block" htmlFor="printOptionTwo">
            <div className="d-flex">
              <div>
                <div className="text-dark">Print Usage</div>
                <div className="mt-1">{aos.image_width}<b> x </b>{aos.image_height} px</div>
              </div>
              <div className="ms-auto me-2 text-end">
                {image_print_price}
              </div>
            </div>
          </label>
        </div>
      </div>
    }

    let related_photos, related_photo_list = this.state.related_photos || this.props.related_photos
    if (related_photo_list) {

      let currentRelatedPhotosPage = this.state.related_photos_current_page || this.props.related_photos_current_page
      let totalPages = this.props.related_photos_pages
      let loadMoreBtn
      if (totalPages > currentRelatedPhotosPage && currentRelatedPhotosPage <= 3) {
        loadMoreBtn = <VisibilitySensor onChange={this.fetchRelatedPhotos}>
          <div>Loading more photos...</div>
        </VisibilitySensor>
      }

      let related_photos_content = related_photo_list.map((related_photo, id) => {
        return <ListPhoto titlePrefix={"Image of "} key={id} photo={related_photo} reference={'/photo/' + related_photo.id}></ListPhoto>
      })

      related_photos = <div className="bg-light pb-5 pt-3">
        <div className="container">
          <h2 className="mb-3">Related Images</h2>
          <div className="row">
            {related_photos_content}
          </div>
          <div className="text-center">
            {loadMoreBtn}
          </div>
        </div>
      </div>
    }

    let mentionedCollectionsRender
    if (mentioned_collections && mentioned_collections.length) {
      mentionedCollectionsRender = mentioned_collections.map((collection) => {
        return <li className="list-inline-item fw-500" key={collection.id}>
          <Link as={`/collections/${collection.slug}`} href={"/collections?collection_slug=" + collection.slug}><a>
            {collection.name}</a></Link></li>
      })
    }
    if (mentionedCollectionsRender) {
      mentionedCollectionsRender = <li className="mb-3"><ul className="list-inline">
        <li className="list-inline-item ">Featured in collection: </li>
        {mentionedCollectionsRender}
      </ul></li>
    }

    add_to_cart_btn = <CartContext.Consumer>
      {

        context => {

          if (this.state.selected_option) {

            return <button className="btn btn-block btn-primary" onClick={(e) => {
              if (getLocalKeyValue(TOKEN)) {
                this.addToCart(e).then((res) => {
                  context.updatecart(res.data.cart, Date.now())
                  this.setState({ 'addedToCart': true })
                  logEvent('Photo', 'AddedToCart')
                  setTimeout(() => {
                    this.setState({ 'addedToCart': false })
                  }, 4000)
                })

              }
              else {
                let ref = "/photo/" + this.props.photo.id
                setSessionKeyValue('referer', ref)
                window.location.href = "/login-customer"
              }

            }}><img src="/static/img/details_photo/download.svg" className="img-fluid me-2" />Download</button>
          }
          else {
            return <button disabled className="btn btn-block btn-primary"><img src="/static/img/details_photo/download.svg" className="img-fluid me-2" />Download</button>
          }

        }
      }
    </CartContext.Consumer>
    if (this.state.selected_option === "buy_sub") {
      add_to_cart_btn = <>
        <Link href="/pricing">
          <a className="btn btn-block btn-primary">Buy Value Pack</a>
        </Link>
      </>
    }


    let digital_btn_text = "Digital Usage: 1 Credit"
    let print_btn_text = "Print Usage: 4 Credits"
    let download_text = <><img src="/static/img/details_photo/download.svg" className="img-fluid me-2" />Download</>

    if (subscription && subscription.credits_remaining && subscription.credits_remaining > 0) {
      add_to_cart_btn = <button onClick={(e) => { this.downloadPhotoFromSubscription(e, this.state.selected_option, photo) }} className="btn btn-block btn-primary">{download_text}</button>
      if (subscription.plan_name === "Free" && this.state.selected_option === "print") {
        add_to_cart_btn = <div className="text-center">
          <Link href="/pricing">
            <a className="btn btn-block btn-primary" title="Please upgrade your subscription plan">Buy Subscription</a>
          </Link>
        </div>
      }
      // digital_price_option = (<button className="btn btn-block btn-primary" onClick={(e)=>{this.downloadPhotoFromSubscription(e, 'digital', photo)}}>{digital_btn_text}</button>)
      // print_price_option= (<button className="btn btn-block btn-primary" onClick={(e)=>{this.downloadPhotoFromSubscription(e, 'print', photo)}}>{print_btn_text}</button>)
      // if (subscription.plan_name==="Free"){
      //   print_price_option= <div className="text-center mt-2">
      //     <button className="btn btn-block btn-primary" disabled title="Please upgrad your subscription plan">{print_btn_text}</button>
      //     <small>To download for print <Link href="/pricing">click here</Link></small>
      //   </div>
      //
      // }

    }
    else if (subscription && subscription.plan_name === "Postpaid") {

      add_to_cart_btn = <button onClick={(e) => { this.downloadPhotoFromSubscription(e, this.state.selected_option, photo) }}>{download_text}</button>
      // digital_price_option = (<button className="btn btn-block btn-primary" onClick={(e)=>{this.downloadPhotoFromSubscription(e, 'digital', photo)}}>{digital_btn_text}</button>)
      // print_price_option= (<button className="btn btn-block btn-primary" onClick={(e)=>{this.downloadPhotoFromSubscription(e, 'print', photo)}}>{print_btn_text}</button>)
    }



    creditsInfo = <div className="text-muted mb-3 font-size-small">{creditsMsg} {cpyBtn}</div>

    let downloadResult
    if (this.state.downloading) {
      // digital_price_option = undefined
      // print_price_option = undefined
      add_to_cart_btn = <button className="btn btn-primary" type="button" disabled>
        <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        Downloading...
      </button>
    }
    if (this.state.download_failed) {
      // digital_price_option = undefined
      // print_price_option = undefined
      add_to_cart_btn = <p className="text-secondary">Download failed, please <Link href="/contact_us">contact</Link> support team.</p>
      if (this.state.download_failed_low) {
        add_to_cart_btn = <p className="text-secondary">You have low credits. Please upgrade your <Link href="/pricing"><b className="text-picxy pointer">Subscription plans</b></Link></p>
      }
    }

    const router = this.props.router

    // Its important to generate multiple sizes for improving speed index
    // srcSet={ASSET_URL+photo.thumbnail_medium + ' 700w,' + ASSET_URL+photo.thumbnail_large+ ' 1000w'}

    let cartActionInfo
    if (this.state.addedToCart) {
      cartActionInfo = <div className="position-fixed text-center text-white" style={{ top: 0, width: '100%', zIndex: 1030 }}>
        <div className="text-dark bg-light shadow mx-auto p-3 animated fadeIn faster" >
          Photo added to cart <FontAwesomeIcon icon={faCheck} className="ms-2 text-success" /> <a href="/cart" className="btn btn-sm btn-outline-primary ms-md-5">View Cart</a>
        </div>
      </div>
    }
    let zoomedComp
    if (this.state.zoom) {
      zoomedComp = <div className="position-fixed bg-light h-100 py-3" style={{ top: 0, zIndex: 1040, left: 0, width: '100%', cursor: 'zoom-out' }} onClick={this.toggleZoom}>
        <div className="animated fadeIn faster d-flex justify-content-center " >
          <img key={photo.id} src={photo.thumbnail_large} className="shadow-lg img-fluid " style={{ maxHeight: '96vh', border: '3px solid white' }} />
        </div>
      </div>
    }
    let imgRender = <img key={photo.id} src={photo.thumbnail_large} className="img-fluid rounded" alt={photo.title} />
    if (photo.thumbs && photo.thumbs.webp_1600) {
      imgRender = <picture >
        <source srcSet={photo.thumbs.webp_1600} type="image/webp" />
        <source srcSet={photo.thumbnail_large} type="image/jpeg" />
        <img key={photo.id} src={photo.thumbnail_large} className="img-fluid rounded" alt={photo.title} />
      </picture>
    }

    let locationHolder
    if (photo.location_name) {
      locationHolder = <li className=" mb-3">
        <span className=" d-sm-inline d-block">Location: </span>
        <span className="text-muted d-sm-inline d-block">{photo.location_name}</span>
      </li>
    }

    let usage = <div>
      <span className="">Model Release: </span><span className="text-muted">{this.props.mr === "yes" ? "Yes" : "NA"}</span> <a href="#" className='fw-500' onClick={this.toggleLicense}>Learn More</a>
      <Modal show={this.state.show_license} onHide={this.toggleLicense} size={"lg"}>
        <Modal.Body>
          <div className="d-flex justify-content-end py-2">
            <a href="/static/img/picxy_photo_license.svg" className="btn btn-sm btn-link" target="_blank">Open in new tab</a> <a href="#" onClick={this.toggleLicense} className="btn btn-sm btn-link">Close</a>
          </div>
          <div className=" py-2">
            <img src="/static/img/picxy_photo_license.svg" className="img-fluid" />
          </div>
        </Modal.Body>

      </Modal>

    </div>

    let buy_sub_className = "border rounded p-2 mb-2"
    if (this.state.selected_option === "buy_sub") {
      buy_sub_className += " bg-dull-secondary"
    }
    let action_buttons = <>
      <div className="border rounded">
        {digital_price_option}
        {print_price_option}
      </div>
      <hr />
      <div className={buy_sub_className}>

        <div className="form-check mt-2">
          <input type="radio"
            id="printOptionThree"
            value="print"
            name="photoPrice" className="form-check-input"

            onClick={(e) => { this.handleSelectPriceOption(e, 'buy_sub') }} checked={this.state.selected_option === "buy_sub" ? true : false} />

          <label className="form-check-label pointer d-block picxy-radio-custom" htmlFor="printOptionThree">
            <div className="">
              <span className="bg-success text-white rounded p-1 small">Super saver plan</span>
            </div>
            <div className="d-flex">
              <div>
                <div className="text-dark">Digital Usage</div>
                <span className="text-success">Save 50%</span>
              </div>
              <div className="ms-auto">
                {/* <span className="f-20 text-dark">&#8377; 100</span> */}
                <span className="f-20 text-dark fw-bold">{priceList["Super Saver"]?.price}</span>
              </div>
            </div>
          </label>
        </div>
        <div className="px-4 mt-3">
          <Link href="/pricing">
            <a>Explore our pricing</a>
          </Link>
        </div>
      </div>

      <div className="mt-4">
        {add_to_cart_btn}
      </div>
    </>

    if (subscription && subscription.credits_remaining && subscription.credits_remaining > 0) {
      action_buttons = <div className="mt-4">
        <div className="border rounded mb-2">
          {digital_price_option}
          {print_price_option}
        </div>
        <div className="mt-4">
          {add_to_cart_btn}
        </div>
      </div>
    }
    let seemore_text = <small>See more</small>
    let seeless_text = <small>See less</small>
    let seemore_text_des = <span>See more</span>
    let seeless_text_des = <span>See less</span>
    let share_url = SITE_URL + this.props.router.asPath
    let photo_title = photo.title.charAt(0).toUpperCase() + photo.title.slice(1)

    return <LayoutBasic title={browser_title} {...this.props} defaultNavBar={true}>

      <SeoMetaPhoto {...this.props} />
      <main>
        <div className="container my-3">
          <div className="row">
            <div className="col-md-8">
              <div className="photo-wrapper zoom" >
                {imgRender}
                {zoomedComp}
              </div>
              <div className="mt-4">
                <div className="row align-items-center">
                  <div className="col-sm-5 ">
                    <Creator photographer={photo.photographer} />
                  </div>

                  <div className="col-sm-7">
                    <div className=" d-flex justify-content-sm-end">
                      <OverlayTrigger trigger={!this.state.userSigndStatus ? ['hover', 'focus'] : "manual"} overlay={(<Popover id="signup"> <Popover.Content>Login to Download </Popover.Content></Popover>)} placement="bottom">
                        <div className="me-3 pointer" onClick={(e) => { this.downloadSamplePhoto(e, photo) }}>
                          <img src="/static/img/details_photo/download_dark.svg" className="img-fluid me-2" />
                          Sample
                        </div>
                      </OverlayTrigger>

                      <div className="me-3 pointer">
                        {like_btn}
                      </div>
                      {viewCount}
                      <div className="me-3 position-relativ" ref={this.wrapperRef}>
                        <div className={this.state.showShare ? "position-absolute bg-light border rounded-lg" : "position-absolute bg-light border d-none"} style={{ zIndex: '999', width: '130px' }} onClick={this.showShareBox}>
                          <div className="p-3">
                            <div className=" mb-2">
                              Share via
                            </div>
                            <div className="border-bottom mb-2">
                              <a target="new" className="" href={"https://www.facebook.com/sharer/sharer.php?u=" + share_url + "&quote=" + photo_title}><FontAwesomeIcon icon={faFacebookF} /> Facebook</a>
                            </div>
                            <div className="border-bottom mb-2">
                              <a className="" href={"https://www.linkedin.com/shareArticle/?url=" + share_url + "&mini=true"} target="new"><FontAwesomeIcon icon={faLinkedin} /> Linkedin</a>
                            </div>
                            <div className="border-bottom mb-2">
                              <a className="" href={"https://twitter.com/intent/tweet?url=" + share_url} target="new"><FontAwesomeIcon icon={faTwitter} /> Twitter</a>
                            </div>
                            <div className="pointer">
                              {copytoClipboardbtn}
                            </div>
                          </div>
                        </div>
                        <div className="share-div pointer" onClick={(e) => { this.showShareBox(e) }}>
                          <img src="/static/img/details_photo/share.svg" className="img-fluid me-1 " /> Share
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="my-3" />
            </div>
            <div className="col-md-4">
              <h1 className=" mb-3 mt-3 mt-md-0">
                <ShowMoreText lines={3} more={seemore_text} less={seeless_text}>{photo_title}</ShowMoreText>
              </h1>
              {action_buttons}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-8">

              <ul className="list list-unstyled">

                <li className="my-3">
                  <span className=" d-sm-inline d-block">Stock Photo ID: </span>
                  <span className="text-muted d-sm-inline d-block">#{photo.pid} {stockIDcpyBtn}</span>
                </li>
                <li className="mb-3">
                  <span className=" d-sm-inline d-block">Image Credit: </span>
                  <span className="text-muted d-sm-inline d-block">Picxy.com/{photographer.username} {cpyBtn}</span>
                </li>
                <li className="mb-3">
                  {usage}
                </li>
                {photo.description && <li className="d-sm-flex mb-3">
                  <div className="d-sm-flex">

                    <div className=" d-sm-inline d-block">Description:&nbsp; </div>
                    <div className="text-muted d-sm-inline d-block">
                      <ShowMoreText lines={1} more={seemore_text_des} less={seeless_text_des}>{photo.description}</ShowMoreText>
                    </div>

                  </div>

                </li>}
                {locationHolder}
                {mentionedCollectionsRender}
                <li className="mb-3">
                  {this.props.mentioned_tags.length > 0 && <SeeMoreList data={this.props.mentioned_tags} title="Tags" />}
                </li>

              </ul>


            </div>
          </div>

          <div className="text-light font-size-small  mb-2">

          </div>

          <div className="text-light font-size-small mt-4 mb-2">

          </div>




        </div>
        {cartActionInfo}
      </main>




      {related_photos}

    </LayoutBasic>
  }

}

export default withRouter(Photo)
